export default __webpack_public_path__ + "static/media/imbbb.40289ad7.jpg";